export const setProductDetails = (productDetails) => localStorage.setItem('productDetails', productDetails);
export const getproductDetails = () => localStorage.getItem('productDetails');

export const setProductMessageResponse = (messageResponse) => localStorage.setItem('messageResponse', messageResponse);
export const getProductMessageResponse = () => localStorage.getItem('messageResponse');

export const setSingleProductCategory = (singleProduct) => localStorage.setItem('singleProduct', singleProduct);
export const getSingleProductCategory = () => localStorage.getItem('singleProduct');
export const deleteSingleCategory = () => localStorage.setItem('singleProduct', undefined);


export const setSelectedListings = (selectedListings) => localStorage.setItem('selectedListings', selectedListings);
export const getSelectedListings = () => localStorage.getItem('selectedListings');
